<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";

const $store = useStore();
const $route = useRoute();
const $router = useRouter();

const unsubscribeJobAlerts = () => {
    if ($router.currentRoute.value.name === 'guest_unsubscribe_jobs') {
        $store
            .dispatch("UNSUBSCRIBE_JOB_ALERT_GUEST", {
                subscriptionId: $route.params.subscriptionId,
            })
            .then((response) => {
                if (response.success) {
                    ElMessage({
                        type: "success",
                        message: response.message,
                    });
                } else {
                    ElMessage({
                        type: "error",
                        message: 'There was an error unsubscribing the job alert subscription. Please try again.',
                    });
                }
                $router.push({
                    name: "job-listing-guest"
                });
            });
    } else {
        $store
            .dispatch("UNSUBSCRIBE_JOB_ALERT")
            .then((response) => {
                if (response.success) {
                    ElMessage({
                        type: "success",
                        message: response.message,
                    });
                } else {
                    ElMessage({
                        type: "error",
                        message: 'There was an error confirming the job alert subscription. Please try again.',
                    });
                }
                $router.push({
                    name: "profile_job_seeker_setting"
                });
            });
    }
};

onMounted(() => {
    unsubscribeJobAlerts();
});

</script>

<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start">
            </ion-buttons>
            <ion-title>Unsubscribe Job Alert</ion-title>
        </ion-toolbar>
        <div class="main_wrapper ion_padding">
            <div class="container">
            </div>
        </div>
    </div>
</template>
